import type { Content } from './types'

export const fr: Content = {
  lang: 'fr',
  hero: {
    h1: 'Votre LinkedIn coûte des clients à chaque jour qui passe.',
    subtitle:
      'En 3 à 5 jours, je le transforme en vitrine professionnelle qui inspire confiance — et convertit.',
    cta: 'Parler à Rebeca sur WhatsApp',
    ctaHref:
      'https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20suis%20int%C3%A9ress%C3%A9(e)%20par%20LinkedIn%20Signature',
    note: 'Réponse garantie en moins de 24h.',
    availability: 'Disponible en français, español & English 🌐',
  },
  problem: {
    title: 'La vérité que personne ne vous dit.',
    paragraphs: [
      "Vos clients idéaux vous cherchent en ligne. Ils trouvent votre profil. Et ils passent à quelqu'un d'autre.",
      "Pas parce que vous n'êtes pas compétent. Parce que votre présence digitale ne reflète pas votre vraie valeur.",
      'Ça vous coûte des clients. Chaque jour.',
      'Et le pire? Vous ne le voyez même pas.',
      'Parce que ces clients-là — ils ne vous contactent jamais.',
      "Ils passent à quelqu'un d'autre en silence.",
    ],
  },
  solution: {
    title: "C'est exactement ce que je règle.\nEn 3 à 5 jours. Garanti.",
    paragraphs: [
      'Je suis Rebeca Oliveira, fondatrice de Visibilia.',
      "Pas une agence. Pas une étudiante en marketing.\nUne femme de terrain — 20 ans de direction d'entreprise internationale.\n5 ans à bâtir la présence digitale d'entrepreneurs et de PME.",
      "J'ai travaillé des deux côtés de la table. Je sais exactement ce que ça coûte d'avoir une mauvaise image en ligne. Et ce que ça rapporte d'en avoir une bonne.",
      {
        text: 'Ce que je crée pour vous — c\'est un profil LinkedIn qui fait dire à vos clients idéaux :\n"Cette personne, je lui fais confiance."',
        quote: true,
      },
    ],
    stats: [
      { value: '20 ans', label: 'Direction\ninternationale' },
      { value: '5 ans', label: 'Médias\nsociaux' },
      { value: '3', label: 'Langues\nFR·ES·EN' },
    ],
    langLine: 'FR · ES · EN 🌐',
  },
  offers: {
    title: 'Choisissez votre forfait.',
    popularBadge: '⭐ LE PLUS POPULAIRE',
    delaiLabel: '⏱ Délai : 3 à 5 jours ouvrables',
    card1: {
      title: '✦ LinkedIn Signature',
      price: '497 $',
      originalValue: 'Valeur réelle : 900 $+',
      description:
        'Votre profil existe déjà. Mais il ne travaille pas pour vous. On change ça.',
      features: [
        'Audit complet de votre profil actuel',
        'Titre stratégique qui positionne',
        'Bannière professionnelle sur mesure',
        'Section À propos qui convertit',
        'Expérience restructurée et valorisée',
        'Section services configurée',
        'URL personnalisée',
        '1 publication de lancement prête à publier',
        "Mini-guide d'utilisation LinkedIn",
        'Appel de remise personnalisé (15 min)',
      ],
      cta: 'Je veux transformer mon LinkedIn',
      ctaHref:
        'https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20veux%20le%20forfait%20LinkedIn%20Signature%20%C3%A0%20497%24',
    },
    card2: {
      title: '✦ LinkedIn Création',
      price: '297 $',
      description:
        "Vous n'avez pas encore de profil. Ou il est vide depuis des années. On part de zéro — et on fait ça bien.",
      features: [
        'Création complète du profil',
        'Bannière professionnelle sur mesure',
        'Titre + bio stratégiques',
        'Section services configurée',
        'URL personnalisée',
        '1 publication de lancement prête à publier',
        "Mini-guide d'utilisation LinkedIn",
      ],
      cta: 'Je veux créer mon LinkedIn',
      ctaHref:
        'https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20veux%20le%20forfait%20LinkedIn%20Cr%C3%A9ation%20%C3%A0%20297%24',
    },
    helperText:
      'Vous ne savez pas lequel vous convient? Écrivez-moi — je vous guide en 5 minutes. ✦',
  },
  faq: {
    title: 'Questions fréquentes.',
    items: [
      {
        q: 'Est-ce que je dois être disponible pendant le processus?',
        a: "Non. Vous remplissez un formulaire en 10 minutes. Je m'occupe du reste.\nVous recevez votre profil complété en 3 à 5 jours. C'est tout.",
      },
      {
        q: 'Comment se passe le paiement?',
        a: 'Virement bancaire, PayPal ou carte de crédit. Vous choisissez ce qui vous convient. Aucune surprise.',
      },
      {
        q: "C'est quoi le processus exactement?",
        a: "1. Vous m'écrivez sur WhatsApp\n2. Je vous envoie un formulaire (10 min)\n3. Je crée votre profil\n4. Vous révisez et approuvez\n5. On fait un appel de remise (15 min)\nSimple. Rapide. Efficace.",
      },
      {
        q: "Est-ce que LinkedIn est important pour mon type d'entreprise?",
        a: 'Si vos clients, partenaires ou employeurs cherchent des professionnels en ligne —\noui, absolument. LinkedIn est la première plateforme de crédibilité professionnelle au monde.',
      },
      {
        q: 'Et si je ne suis pas satisfait?',
        a: "On révise ensemble jusqu'à ce que votre profil vous représente parfaitement.\nVotre satisfaction est ma priorité. ✦",
      },
    ],
  },
  finalCta: {
    title:
      'Votre LinkedIn peut commencer à travailler pour vous dès cette semaine.',
    subtitle:
      '3 à 5 jours. Un profil professionnel, stratégique, qui reflète enfin votre vraie valeur.',
    cta: 'Écrire à Rebeca sur WhatsApp',
    ctaHref:
      'https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20suis%20pr%C3%AAt(e)%20%C3%A0%20transformer%20mon%20LinkedIn',
    note: 'Aucun engagement. Juste une conversation. Je réponds en moins de 24h. ✦',
    closing:
      'Vous avez travaillé fort pour bâtir votre expertise. Il est temps que votre LinkedIn le montre. ✦',
  },
}
